import { StyleSheet, View } from "react-native";

import { Typography } from "@smartrent/ui";

export const RowHeader = ({ index }) => {
  return (
    <View style={styles.root}>
      <Typography type="bodySmallSemibold">R{index + 1}</Typography>
    </View>
  );
};

const styles = StyleSheet.create({
  root: {
    flexDirection: "column",
    alignItems: "flex-end",
    justifyContent: "center",
    height: "100%",
  },
});
